export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;

export const MESSAGES = {
  UPLOAD_DIALOG_TITLE: "File Uploading",
  UPLOAD_DIALOG_WARNING:
    "To ensure the successful upload, please avoid clicking the back button, leaving the page, or refreshing it during the upload process",
  DROPZONE_HINT: "Drag and drop to upload or browse for files",
  DROPZONE_FILE_HINT: "(Only csv file with size <= 10 MB is allowed)",
  DROPZONE_REJECT: "Some file types are not supported",
  INVALID_FILE_TYPE: "Incorrect file format, please upload CSV file.",
  INVALID_FILE_FORMAT:
    "Incorrect file format, please check column headers, column sequence, column data and upload file with correct template.",
  INVALID_FILE_EMPTY: "Please select a valid file to proceed",
  UPLOAD_FAILED_TITLE: "Upload Failed",
  UPLOAD_SUCCESS_TITLE: "Upload Successful",
  UPLOAD_SUCCESS_MSG: "Receipt file uploaded successfully.",
  UPLOAD_API_ERROR_MSG: "Failed to upload the file. Please try again later.",
  DOWNLOAD_ERROR_LINK: "click here to download the error records",
};

export const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
};

export const focusedStyle = { borderColor: "#2196f3" };
export const acceptStyle = { borderColor: "#00e676" };
export const rejectStyle = { borderColor: "#ff1744" };

export const PO_RECEIPT_UPLOAD_CSV_HEADERS = [
  { name: "asnId", inputName: "asnId" },
  { name: "shippedFromLocationId", inputName: "shippedFromLocationId" },
  { name: "receiptLocationId", inputName: "receiptLocationId" },
  { name: "receiptDate", inputName: "receiptDate" },
  { name: "containerId", inputName: "containerId" },
  { name: "orderId", inputName: "orderId" },
  { name: "itemId", inputName: "itemId" },
  { name: "packId", inputName: "packId" },
  { name: "receiptedQuantity", inputName: "receiptedQuantity" },
  { name: "receiptedQuantityType", inputName: "receiptedQuantityType" },
  { name: "receiptedWeight", inputName: "receiptedWeight" },
  { name: "receiptedWeightType", inputName: "receiptedWeightType" },
];
